
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Grid } from '@mui/material';
import { useConsumosXLote, useDescuentosXLote, useDistriAndDescuentos, useLoteDistriXID, useTotalesDescuento } from '../../../hooks';
import { DisenioLoteDistribuido } from '../../layout';
import { CargandoMedio, TarjetaIndicador } from '../../components';






export const DetallesTotalesLote = () => {


    const { id } = useParams();
    const { loteDistriXIDQuery } = useLoteDistriXID(`${id}`);
    const { descuentosXLoteQuery } = useDescuentosXLote(id);
    const { consumosXLoteQuery } = useConsumosXLote(id);
    const { handleNavegar, handleNavegarPlanilla, handleNavegarConsumo } = useDistriAndDescuentos();
    const descuentos = descuentosXLoteQuery?.data;
    const consumos = consumosXLoteQuery?.data;
    const { consumido, totales } = useTotalesDescuento(consumos, descuentos);


    const data = [
        {key: 1, titulo: 'VENTA', color: '#388E3C', valor: totales.venta, action: handleNavegarPlanilla },
        {key: 2, titulo: 'MORTALIDAD', color: '#D32F2F', valor: totales.mortalidad, action: handleNavegar },
        {key: 3, titulo: 'TRASLADO', color: '#FFA000', valor: totales.traslado, action: handleNavegar },
        {key: 4, titulo: 'DESCUENTO', color: '#616161', valor: totales.descuento, action: handleNavegar },
    ]


    return (

        <DisenioLoteDistribuido titulo="Detalles de lote distribuido">
            {(loteDistriXIDQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Información" />
            
            :   <Grid container spacing={4}> 
                    <TarjetaIndicador valor={consumido.consu} color={'#A67C52'} titulo="CONSUMO COMIDA"
                        total={consumido.sugeri} funcion={ handleNavegarConsumo }
                    />

                    {data.map( item => (
                    <TarjetaIndicador key={item.key} valor={item.valor} color={item.color} titulo={item.titulo}
                        total={loteDistriXIDQuery?.data?.cantidad} funcion={ item.action }
                    />
                    ))}
                </Grid>
            }
        </DisenioLoteDistribuido>
    )
}
